import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

/**
 * Badge Component - Prozpector CRM Design System
 *
 * Variants:
 * - default: Rose red - general purpose
 * - success: Green - Active/Positive status
 * - destructive: Red - Inactive/Negative status
 * - outline: Transparent with border
 * - secondary: Muted - neutral status
 */

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-3.5 py-0.5 text-xs font-semibold transition-colors whitespace-nowrap",
  {
    variants: {
      variant: {
        // Default: Army Green background
        default: "bg-primary text-white border border-primary",

        // Success: Green - for Active/Positive status indicators
        success: "bg-success text-white border border-success",

        // Destructive: Red - for Inactive/Negative status indicators
        destructive: "bg-destructive text-white border border-destructive",

        // Outline: Army Green border
        outline: "bg-background text-primary border border-primary/50",

        // Secondary: Muted
        secondary: "bg-muted text-foreground border border-border",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
